var CONTAINER_SELECTOR = '.pictrue, .gridPic, .image-preview-wrapper';
var BUTTON_ATTRIBUTE = 'data-image-preview-eye';
var scheduled = false;
function openImagePreview(source) {
  var existing = document.getElementById('global-image-preview-overlay');
  if (existing) existing.remove();
  var overlay = document.createElement('div');
  overlay.id = 'global-image-preview-overlay';
  overlay.className = 'global-image-preview-overlay';
  var image = document.createElement('img');
  image.src = source;
  image.alt = '图片预览';
  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'global-image-preview-close';
  close.setAttribute('aria-label', '关闭预览');
  close.innerHTML = '&times;';
  var closeOverlay = function closeOverlay() {
    overlay.remove();
    document.removeEventListener('keydown', onKeydown);
  };
  var onKeydown = function onKeydown(event) {
    if (event.key === 'Escape') closeOverlay();
  };
  close.addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeOverlay();
  });
  overlay.appendChild(image);
  overlay.appendChild(close);
  document.body.appendChild(overlay);
  document.addEventListener('keydown', onKeydown);
}
function enhanceContainer(container) {
  if (!container || container.querySelector("[".concat(BUTTON_ATTRIBUTE, "]"))) return;
  if (container.querySelector('.grid-preview-trigger')) return;
  var image = Array.from(container.querySelectorAll('img')).find(function (item) {
    return item.currentSrc || item.src;
  });
  if (!image) return;
  if (window.getComputedStyle(container).position === 'static') {
    container.style.position = 'relative';
  }
  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'global-image-preview-eye';
  button.title = '预览图片';
  button.setAttribute('aria-label', '预览图片');
  button.setAttribute(BUTTON_ATTRIBUTE, '1');
  button.innerHTML = '<i class="el-icon-view"></i>';
  button.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    var source = image.currentSrc || image.src;
    if (source) openImagePreview(source);
  });
  container.appendChild(button);
}
function scan(root) {
  if (root && root.matches && root.matches(CONTAINER_SELECTOR)) enhanceContainer(root);
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll(CONTAINER_SELECTOR).forEach(enhanceContainer);
}
function scheduleScan(root) {
  if (scheduled) return;
  scheduled = true;
  window.requestAnimationFrame(function () {
    scheduled = false;
    scan(root || document);
  });
}
export default function installImagePreviewEnhancer() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var start = function start() {
    scan(document);
    document.addEventListener('mouseover', function (event) {
      var target = event.target;
      var container = target && target.closest && target.closest(CONTAINER_SELECTOR);
      if (container) enhanceContainer(container);
    }, true);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          var container = node.closest && node.closest(CONTAINER_SELECTOR);
          if (container) enhanceContainer(container);
          scheduleScan(node);
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {
    once: true
  });else start();
}